import QueryString from "qs";
import GhostPage from "@/Components/pages/GhostPage";
import TechnologyPage from "@/Components/pages/TechnologyPage";
import { GetServerSideProps, NextPage } from "next";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

interface TechServiceProps {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }
  const slug = (ctx?.params?.slug as string) ?? "";

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep, 8",
    },
    {
      encodeValuesOnly: false,
    }
  );
  apiRes = await fetch(`${baseUrl}tech-services?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();

  // isNew = apiResData?.data[0]?.attributes?.design === "new";
  isNew = true;

  return {
    props: {
      apiResData,
      isNew,
      slug,
    },
  };
};

const TechService: NextPage<TechServiceProps> = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <div>
        {apiResData.data[0].attributes.template === "ghost-page" ? (
          <GhostPage slug={slug} data={apiResData} />
        ) : (
          <TechnologyPage slug={slug} data={apiResData} isPreview />
        )}
      </div>
    </div>
  );
};

export default TechService;
